module.exports = __webpack_public_path__ + "img/logo.c0593be4.png";